import { Navigate } from 'react-router-dom';
import { useClinicalApprovalAccess } from '../hooks/useClinicalApprovalAccess';

export default function ClinicalApprovalProtectedRoute({ children, fallbackPath = '/admin/clinical' }) {
  const { canApproveClinicalDocuments, loading } = useClinicalApprovalAccess();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50 dark:bg-gray-900">
        <p className="text-sm text-gray-600 dark:text-gray-400">Verifying clinical approval access...</p>
      </div>
    );
  }

  return canApproveClinicalDocuments ? children : <Navigate to={fallbackPath} replace />;
}
